module.exports = __webpack_public_path__ + "static/media/post-es.5824df52.png";